import awards from "../../shared/us.awards";
import branded_quotes from "../../shared/us.branded_quotes";
import verticals from "./us-services.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "us-services-404":
            return {
                page,
                helmet: {
                    meta_title: "Page Not Found | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/services/404",
                    lang: "en"
                },
                eloquaPage: "resources",
                ...pageFooter({ strings })
            };
        case "us-services-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "Online Language Learning for Higher Ed | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
                    canonical_url: "https://www.rosettastone.com/services/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "us-services-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "Resources for Online Language Learning for Higher Ed | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
                    canonical_url: "https://www.rosettastone.com/highereducation/resources/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
